<template>
  <el-dialog
      :visible.sync="visible"
      custom-class="no-header"
      @close="clearData"
      width="520px">
<!--    <div class="close" @click="closeDialog"><i class="el-icon-close"></i></div>-->
    <ScannerCodeLogin v-if="type == 'code'"
                      @loginSuccess="loginSuccess"
                      @bindMobile="bindMobile"/>
    <div v-show="type === 'mobile'" class="register">
      <p class="title">免费注册</p>
      <div class="container">
        <div style="margin-top: 48px">
          <span class="error" v-if="!mobileValid && mobileFocus">请输入正确的手机号！</span>
          <el-input v-model="bindData.mobile"
                    prefix-icon="el-icon-mobile-phone"
                    placeholder="请输入手机号"
                    @focus="mobileFocus = true"
                    :class="{validError: !mobileValid && mobileFocus}"
                    @input="checkMobile"/>
        </div>
        <div id="ncRegister" class="nc"></div>
        <VerificationCode v-model="bindData.code"
                          v-if="type === 'mobile'"
                          :mobile="bindData.mobile"
                          :check-flag="validFlag && mobileValid"/>
        <el-popover
            placement="left"
            width="400"
            trigger="focus">
          <el-input slot="reference"
                    class="password"
                    :class="{validError: passwordFocus && percentage<85}"
                    prefix-icon="el-icon-lock"
                    show-password
                    @focus="passwordFocus = true"
                    @input="setPercent"
                    v-model='bindData.password'
                    placeholder="请设置您的登录密码"/>
          <p class="tip" :style="{color: customColorMethod(percentage)}">
            强度：{{ tipContent }}
          </p>
          <el-progress :percentage="percentage" :color="customColorMethod"></el-progress>
          <p class="info">请至少输入 6 个字符。请不要使用容易被猜到的密码。</p>
        </el-popover>
        <div style="margin-bottom: 48px">

          <el-input prefix-icon="el-icon-lock"
                    placeholder="请再次输入您的登录密码"
                    :class="{validError: checkPsdFocus && !checkPsdValid}"
                    @focus="checkPsdFocus = true"
                    v-model="checkPassword"
                    show-password/>
          <span class="error bottom" v-if="checkPsdFocus && !checkPsdValid">两次密码不一致！</span>
        </div>
        <div class="has-account" @click="goToLogin">使用已有账号登录</div>
        <div class="button" :class="{disabled: !submitValid}" @click="registerSubmit">立即注册</div>
        <p class="agreement">注册即视为同意 <span @click="openAgreement">《用户协议》</span></p>
      </div>
    </div>
  </el-dialog>
</template>

<script>

  import apis from "@/api/apis";
  import auth from "@/utils/auth.js";
  import VerificationCode from '@/components/front/tool/VerificationCode.vue'
  import ScannerCodeLogin from '@/components/front/ScannerCodeLogin.vue'

  export default {
    name: 'frontRegister',
    components: {VerificationCode, ScannerCodeLogin},
    data() {
      return {
        type: '',// 'code':先扫码，’mobile‘：再验证手机号
        percentage: 0,
        tipContent: '太短',
        visible: false,
        mobileValid: false,// 手机号是否合格
        psdValid: false,// 密码是否合格
        checkPsdValid: false,// 两次输入密码是否一致
        checkPsdFocus: false, // 是否聚焦过确认密码
        mobileFocus: false, // 是否聚焦过手机号
        passwordFocus: false, // 是否聚焦过密码
        ncRegister: null,
        code: {
          login_id: '',
          qr_url: '',
        },
        checkPassword: '', // 第二次密码
        bindData: {
          mobile: '', // 手机号
          code: '', // 手机验证码
          password: '',

          openid: '', // 扫码授权后返回的openid
          login_id: '', // 扫码授权后返回的access_token

          sessionId: '', // 滑动验证功能：必填参数，从前端获取，不可更改，android和ios只传这个参数即可
          slideToken: '', // 滑动验证功能：必填参数，从前端获取，不可更改
          sig: '', // 滑动验证功能：必填参数，从前端获取，不可更改
          scene: 'nc_register', // 滑动验证功能：必填参数，从前端获取，不可更改，登录则传：nc_login，注册则传：nc_register
        },

        validFlag: false, // 滑动是否通过
      }
    },
    computed: {
      submitValid() {
        return this.mobileValid
            && this.percentage > 85
            && this.checkPsdValid
            && this.validFlag
            && this.bindData.code
      },
    },
    mounted() {
      if (this.type === 'mobile') {
        this.initNC()
      }
    },
    methods: {
      closeDialog(){
        this.visible = false
        this.clearData()
      },
      openAgreement(){
        window.open('http://www.wikeyun.cn/agreement/detail.html?id=343', '_blank')
      },
      clearData() {
        this.validFlag = false // 拖动验证
        this.mobileValid = false// 手机号是否合格
        this.psdValid = false// 密码是否合格
        this.checkPsdValid = false// 两次输入密码是否一致
        this.checkPsdFocus = false // 是否聚焦过确认密码
        this.mobileFocus = false // 是否聚焦过手机号
        this.passwordFocus = false // 是否聚焦过密码

        this.checkPassword = '' // 第二次密码
        this.bindData = {
          mobile: '', // 手机号
          code: '', // 手机验证码
          password: '',

          openid: '', // 扫码授权后返回的openid
          login_id: '', // 扫码授权后返回的access_token

          sessionId: '', // 滑动验证功能：必填参数，从前端获取，不可更改，android和ios只传这个参数即可
          slideToken: '', // 滑动验证功能：必填参数，从前端获取，不可更改
          sig: '', // 滑动验证功能：必填参数，从前端获取，不可更改
          scene: 'nc_register', // 滑动验证功能：必填参数，从前端获取，不可更改，登录则传：nc_login，注册则传：nc_register
        }
        this.type = ''
      },
      checkMobile() {
        if (/^1[3456789]\d{9}$/.test(this.bindData.mobile)) {
          this.mobileValid = true
        } else {
          this.mobileValid = false
        }
      },
      customColorMethod(percentage) {
        if (percentage <= 25) {
          this.tipContent = '太短'
          return '#F5222D';
        } else if (percentage >= 90) {
          this.tipContent = '强'
          return '#52C41A';
        } else {
          this.tipContent = '中等'
          return '#dde502'
        }
      },
      setPercent() {
        this.percentage = 0
        const psd = this.bindData.password
        if (psd.length === 0) {
          return
        }
        if (psd.length < 6) {
          this.percentage = 10
          return
        }
        if (psd.length > 8) {
          this.percentage = 25
        }
        // 判断这个字符串中有没有数字
        if (/[0-9]/.test(psd)) {
          this.percentage += 25
        }
        // 判断字符串中有没有字母
        if (/[a-zA-Z]/.test(psd)) {
          this.percentage += 25
        }
        // 判断字符串中有没有特殊符号
        if (/[^0-9a-zA-Z_]/.test(psd)) {
          this.percentage += 25
        }
      },
      registerSubmit() {
        if (!this.submitValid) {
          return
        }
        apis.register.bindMobile(this.bindData).then(res => {
          this.$notify({
            title: '通知',
            message: res.msg,
          })
          auth.saveUser(res.data.userinfo)
          auth.saveToken(res.data.userinfo.token)
          auth.saveSkey(res.data.security_key)
          this.loginSuccess()
        })
      },
      loginSuccess() {
        this.$emit('loginSuccess')
        this.visible = false
      },
      bindMobile(loginId, openId) {
        this.type = 'mobile'
        this.bindData.login_id = loginId
        this.bindData.openid = openId
      },
      initNC() {
        var nc_token = ["FFFF0N0000000000A608", (new Date()).getTime(), Math.random()].join(':');
        // 实例化nc
        if (this.visible && !this.ncRegister) {
          // eslint-disable-next-line no-undef
          AWSC.use("nc", (state, module) => {
            // 初始化
            this.ncRegister = module.init({
              // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
              appkey: "FFFF0N0000000000A608",
              //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
              token: nc_token,
              trans: {"key1": "code0"},
              elementID: ["usernameID"],
              is_Opt: 0,
              language: "cn",
              isEnabled: true,
              timeout: 3000,
              times: 5,
              //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
              scene: "nc_register",
              // 声明滑动验证需要渲染的目标ID。
              renderTo: "ncRegister",
              width: '368',
              //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
              success: (data) => {
                this.bindData.sessionId = data.sessionId
                this.bindData.slideToken = data.token
                this.bindData.sig = data.sig
                this.validFlag = true
              },
              // 滑动验证失败时触发该回调参数。
              fail: (failCode) => {
                console.log(failCode)
              },
              // 验证码加载出现异常时触发该回调参数。
              error: (errorCode) => {
                console.log(errorCode)
              },
            })
          })
        }else if(this.ncRegister){
          this.ncRegister.reset()
        }
      },
      showDialog(loginId, openId) {
        console.log(this.type, '-----------------------')
        this.visible = true
        if (loginId && openId) { // 登录时候扫码发现没绑定手机号跳到这里
          this.type = 'mobile'
          this.bindData.login_id = loginId
          this.bindData.openid = openId
        } else {
          this.type = 'code'
        }
      },
      goToLogin() {
        this.visible = false
        this.$emit('login')
      },
    },
    watch: {
      visible(value) {
        if (value) {
          this.$nextTick(this.initNC)
        }
      },
      'bindData.password'(value) {
        if (this.checkPassword === value) {
          this.checkPsdValid = true
        } else {
          this.checkPsdValid = false
        }
      },
      checkPassword(value) {
        if (this.bindData.password === value) {
          this.checkPsdValid = true
        } else {
          this.checkPsdValid = false
        }
      },
    },
  }

</script>

<style lang="scss" scoped>
  .no-header{
    position: relative;
    .close{
      width: 40px;
      height: 40px;
      position: absolute;
      top: -45px;
      right: -45px;
      font-size: 30px;
      background: #767575a1;
      border-radius: 50%;
      padding: 5px;
      color: #bdbbbb;
      &:hover{
        transform: scale(1.1);
      };
    }
  }

  .el-input.validError {
    ::v-deep.el-input__inner, ::v-deep.el-input__inner:focus {
      border-color: red;
    }
  }

  .register {
    padding: 31px 56px;

    .title {
      font-size: 24px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 33px;
    }

    .container {
      width: 368px;

      & > div {
        margin-top: 32px;
        position: relative;

        .error {
          font-size: 12px;
          font-weight: 400;
          color: #FF4D4F;
          line-height: 24px;
          position: absolute;
          top: -24px;
          left: 0;

          &.bottom {
            bottom: -24px;
            top: auto;
          }
        }
      }

      ::v-deep.nc-container .nc_scale .nc_iconfont {
        box-sizing: content-box;
      }

      .has-account {
        font-size: 14px;
        font-weight: 500;
        color: #0B4FFC;
        line-height: 22px;
        cursor: pointer;
      }

      .button {
        margin-top: 8px;
        width: 368px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #0B4FFC;
        border-radius: 4px;
        font-size: 16px;
        color: #fff;
        cursor: pointer;

        &.disabled {
          opacity: 0.2;
          cursor: not-allowed;
        }
      }

      .agreement {
        font-size: 14px;
        font-weight: 400;
        margin-top: 32px;
        line-height: 22px;
        text-align: center;

        span {
          color: #FC2326;
          cursor: pointer;
        }
      }

      .password {
        margin-top: 32px;
      }

      .warn {

        .tip {
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          text-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
          margin-bottom: 10px;

          &.red {
            color: #F5222D;
          }
        }

        .info {
          margin-top: 16px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 22px;
          text-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }
</style>
